import React, { useState } from "react";
import { Tooltip } from "@/components/common/Tooltip";
import { HoverCardSurface } from "@/components/common/HoverCard";
import { TableColumnHoverCard } from "@/components/canvas/leftSide/import/Connections/TableColumnHoverCard";
import { SearchTableResult } from "./appSearchApi";
import { useSearchTableColumns } from "./tableColumnsPreview";

/**
 * Schema popover for table rows in the search dropdown — same hover-card
 * pattern as the import tree's connector tables (`TableItem`). Columns are
 * `can_discover`-gated server-side, so locked rows get the popover too.
 */
export const TableSchemaPopover: React.FC<{
  table: SearchTableResult;
  children: React.ReactNode;
}> = ({ table, children }) => {
  const [open, setOpen] = useState(false);
  const { preview, ensureLoaded } = useSearchTableColumns(table.id, table.name);

  const hoverCard = (
    <HoverCardSurface>
      <TableColumnHoverCard preview={preview} />
    </HoverCardSurface>
  );

  return (
    <Tooltip
      title={hoverCard}
      placement="right"
      variant="card"
      interactive
      open={open}
      onOpen={() => {
        setOpen(true);
        ensureLoaded();
      }}
      onClose={() => setOpen(false)}
    >
      <div>{children}</div>
    </Tooltip>
  );
};
